import React, { Fragment } from "react";
import { DocumentScanner } from "@mui/icons-material";

export interface IBarcodeScannerProps {
    onValueScan: ((value: string) => void) | undefined;
}

export const BarcodeKeyboardScanner = (props: IBarcodeScannerProps) => {
    if (!props.onValueScan) {
        return <Fragment />;
    }

    return <div className={"scanner-content"}>
        <div className={"scanner-content__wrapper"}>
            <DocumentScanner className={"scanner-content__icon"} />
        </div>
    </div>;
};
